import './index.css';
import { useMemo } from 'react';

const useFilePreview = ({ loadedFile, isImageType }) => {
    return useMemo(() => {
        if (!loadedFile || !isImageType) {
            return 'none';
        }
        if (loadedFile.loading || loadedFile.error) {
            return 'none';
        }
        return URL.createObjectURL(loadedFile.data);
    }, [loadedFile, isImageType]);
};

export { useFilePreview };
//# sourceMappingURL=useFilePreview.js.map
